/**
 * 관세사무소 목록 — 공개 번들에는 사무소 이름·번호를 두지 않는다.
 * 관리자 토큰이 있을 때만 서버(/api/onto/admin/office-groups)에서 받는다.
 * 목록이 없으면 사무소 선택 UI를 숨긴다.
 */
import { useEffect, useState } from "react";

function adminToken() {
  try {
    return localStorage.getItem("admin_token") || "";
  } catch {
    return "";
  }
}

export function useOfficeGroups() {
  const [state, setState] = useState({ groups: [], loaded: false });
  useEffect(() => {
    let alive = true;
    const token = adminToken();
    if (!token) {
      setState({ groups: [], loaded: true });
      return undefined;
    }
    fetch("/api/onto/admin/office-groups", { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => (r.ok ? r.json() : { groups: [] }))
      .then((d) => {
        if (alive) setState({ groups: Array.isArray(d.groups) ? d.groups : [], loaded: true });
      })
      .catch(() => {
        if (alive) setState({ groups: [], loaded: true });
      });
    return () => {
      alive = false;
    };
  }, []);
  return state;
}
